import React from 'react';
import MinimalVariant from './MinimalVariant';
import ModernVariant from './ModernVariant';
import CorporateVariant from './CorporateVariant';
import CreativeVariant from './CreativeVariant';
import GridVariant from './GridVariant';
import MagazineVariant from './MagazineVariant';
import ProfessionalVariant from './ProfessionalVariant';
import CleanVariant from './CleanVariant';
import LandingVariant from './LandingVariant';
import ElegantVariant from './ElegantVariant';
import DarkVariant from './DarkVariant';

const VariantManager = ({ variant = 'corporate', heroContent, brand, domainConfig }) => {
  // Map variant names to components
  const variantComponents = {
    'minimal': MinimalVariant,
    'modern': ModernVariant,
    'corporate': CorporateVariant,
    'creative': CreativeVariant,
    'grid': GridVariant,
    'magazine': MagazineVariant,
    'professional': ProfessionalVariant,
    'clean': CleanVariant,
    'landing': LandingVariant,
    'elegant': ElegantVariant,
    'dark': DarkVariant
  };

  const VariantComponent = variantComponents[variant] || CorporateVariant;

  return <VariantComponent heroContent={heroContent} brand={brand} domainConfig={domainConfig} />;
};

export default VariantManager;
